{
  "title": "Personalize your space",
  "intro": "The subscription raises some limits and unlocks personalization options. It grants no progression advantage: odds, prices and rewards stay identical for everyone.",
  "offer": {
    "included": "Included in the subscription"
  },
  "memberBadge": "Premium supporter",
  "requiresPremium": "Included with Premium",
  "free": "Free",
  "perMonth": "per month",
  "passTagline": "Comfort, not power.",
  "renewal": "Automatically renewing monthly subscription. Cancel at any time before the next renewal.",
  "passComfort": "Up to 50 boosters per opening, 12 showcase cards",
  "passIdentity": "Custom appearance and images",
  "passSupport": "You help cover the site’s running costs",
  "subscribe": "Subscribe for {{price}}/month",
  "signIn": "Sign in to subscribe",
  "startFree": "Or start playing for free",
  "opening": "Opening Stripe…",
  "loading": "Checking availability…",
  "soon": "Subscriptions opening soon",
  "active": "Your Premium is active",
  "paidUntil": "Paid access through {{date}}.",
  "endsOn": "Renewal canceled. Access through {{date}}.",
  "manage": "Manage my subscription and invoices",
  "customize": "Customize my profile",
  "secure": "Payments and billing secured by Stripe",
  "notReady": "Subscriptions are being configured. You can explore the offer; no payment can be made yet.",
  "verifyEmail": "Verify your email from your profile before subscribing.",
  "testMode": "Stripe test environment: no real money is charged.",
  "acceptBefore": "I accept the",
  "salesTerms": "sales terms",
  "acceptAfter": " and automatic renewal at {{price}} per month.",
  "paymentFailed": "The request could not be completed",
  "redirectInvalid": "The payment address returned is not an authorized Stripe page.",
  "confirming": "We are waiting for Stripe to confirm the payment. Returning to this page alone does not activate Premium.",
  "confirmationSlow": "Confirmation is taking longer. Refresh your status or check billing management before trying to buy again.",
  "checkoutCancelled": "You left the payment page. This return alone does not activate Premium.",
  "suspended": "A full refund, dispute or payment warning has suspended this access. Contact the administration to review the case.",
  "fairness": {
    "title": "No shortcut to victory.",
    "body": "The subscription grants no extra Anima, boosters, fragments or XP. Odds, Anima prices and market rules stay identical for every player."
  },
  "compare": {
    "eyebrow": "Comparison",
    "title": "Free or Premium",
    "intro": "Collection, progression, market, auctions and trades stay available without a subscription.",
    "feature": "Feature",
    "batch": "Boosters openable at once",
    "friends": "Friends",
    "requests": "Pending friend requests",
    "showcase": "Showcase cards",
    "listings": "Simultaneous listings",
    "auctions": "Simultaneous auctions",
    "tradeCards": "Cards per side of a trade",
    "tradeAnima": "Anima per trade",
    "palette": "Personal site colors",
    "defaultPalette": "Day/Night themes",
    "personalPalette": "Private Day/Night palette",
    "progress": "Rates, rewards and progression",
    "cosmetics": "Profile appearance",
    "same": "Identical",
    "earned": "Earned through play",
    "extra": "Gameplay + Premium appearance",
    "note": "Daily quotas, fees, listing and auction slots and free recharges stay identical for everyone. Only the card and Anima limits of a trade are higher for a Premium player."
  },
  "support": {
    "title": "A subscription to support ANIDEX",
    "body": "ANIDEX needs hosting, a database, image storage, email and real-time services. A growing collection and community have real costs. Premium helps cover them, without inventing a figure or claiming to fund the entire site on its own.",
    "promise": "You support the site’s hosting without buying an advantage in the game."
  },
  "faq": {
    "title": "Frequently asked questions",
    "necessary": {
      "question": "Do I have to pay to progress?",
      "answer": "No. Collection, free boosters, quests, progression, the market, auctions and trades remain playable without a subscription. Premium adds no reward multiplier."
    },
    "boosters": {
      "question": "Is this the same as the Premium Booster?",
      "answer": "No. The in-game Premium Booster is obtained with Anima or gameplay rewards. ANIDEX Premium subscriptions do not gift any boosters or change any draws. Openings of 50 use only your stock and Anima."
    },
    "cancel": {
      "question": "How do I stop renewal?",
      "answer": "Open Manage my subscription and invoices. The Stripe portal lets you cancel renewal, update your payment method and view invoices. A normal cancellation keeps access until the end of the period already paid for."
    },
    "expiry": {
      "question": "What happens when Premium expires?",
      "answer": "No cards, friends or game resources are deleted. Free limits return. Existing friends remain, but you must get below the limit before adding more. The first six showcase slots remain visible; the others are saved. Premium appearance, images and palettes become inactive and can return when you resubscribe. A recorded trade offer retains its terms; new offers and counter-offers use each player's current limits."
    },
    "images": {
      "question": "Which images can I upload?",
      "answer": "Static PNG, JPEG or WebP images you have rights to use, up to 15 MB, 4 megapixels and 4096 pixels per side. You can customize {{max}} card portraits plus your avatar and banner. Images do not transfer to buyers or trade recipients."
    },
    "refund": {
      "question": "What if I want a refund?",
      "answer": "Read the sales terms and contact the operator through the contact details in the legal notice. Applicable legal rights, including withdrawal rights where applicable, are preserved. A refund is distinct from canceling renewal."
    }
  },
  "readTerms": "Read the sales terms",
  "tradeRules": "Premium: up to {{cards}} cards and {{anima}} Anima offered per side of a trade. Each player's own cap applies. Fees and listing/auction caps remain unchanged.",
  "palette": {
    "title": "My site colors",
    "settingsHint": "A private Premium palette for your Day and Night themes.",
    "intro": "These colors are for your account only. They follow your signed-in devices and do not change cards, rarities or other players' profiles.",
    "requiresPremium": "Customization requires active Premium.",
    "discover": "Explore Premium",
    "editingTheme": "Palette to edit",
    "themes": {
      "light": "Day",
      "dark": "Night"
    },
    "previewTheme": "The site currently previews {{theme}}.",
    "enable": "Use my colors for the {{theme}} theme",
    "colorsLabel": "Palette colors",
    "colors": {
      "background": "Site background",
      "surface": "Panels",
      "text": "Main text",
      "mutedText": "Secondary text",
      "primary": "Primary buttons",
      "accent": "Accents",
      "success": "Confirmations",
      "danger": "Warnings"
    },
    "hexLabel": "{{color}}, hexadecimal value",
    "sample": "Your palette example",
    "sampleTitle": "Your collection space",
    "sampleBody": "Readable text and colors that feel like you.",
    "sampleButton": "Example button",
    "contrast": "Button and link labels are adjusted to remain readable. Closing without saving restores your previous palette.",
    "invalid": "Use #RRGGBB hex colors.",
    "save": "Save my colors",
    "saving": "Saving…",
    "saved": "Personal colors saved",
    "failed": "Colors could not be saved",
    "resetAll": "Restore ANIDEX colors",
    "cancel": "Cancel"
  },
  "images": {
    "avatar": "Personal avatar",
    "banner": "Personal banner",
    "card": "Personal card portrait",
    "hint": "Static PNG, JPEG or WebP. Up to 15 MB and 4 megapixels. Up to {{max}} card portraits plus one avatar and banner.",
    "choose": "Choose an image to upload",
    "preview": "Current personal image",
    "discover": "Explore personal images with Premium",
    "reset": "Restore the original image",
    "resetDone": "Original image restored",
    "saved": "Personal image saved",
    "saving": "Saving the image…",
    "failed": "The image could not be saved",
    "tooLarge": "This image exceeds 15 MB. Reduce its size before uploading.",
    "rights": "Upload only authorized images without sensitive information. Images are accessible through their URLs during an active Premium subscription, even with restricted profile visibility. Content and moderation rules still apply.",
    "stored": "Saved images: {{count}}/{{max}} card portraits",
    "storedHint": "Free a slot by removing an image, even after selling or trading the card. Removed images are no longer available in old shares.",
    "inactive": "Image inactive without Premium",
    "noLongerOwned": "Card no longer in your collection",
    "remove": "Remove image"
  },
  "boosterHint": "Premium lets you open up to 50 boosters at once, without changing the price or the odds.",
  "profileLink": "Premium: comfort, style and billing",
  "tour": {
    "title": "Premium guide",
    "progress": "Step {{current}} of {{total}}",
    "dotsLabel": "Guide progress",
    "skip": "Skip the guide",
    "back": "Back",
    "next": "Next",
    "finish": "Done",
    "reopen": "Replay the guide",
    "steps": {
      "welcome": {
        "title": "Premium is now active",
        "body": "Your subscription is confirmed. This guide walks through the features that just switched on and where to use them. You can replay it from this page at any time.",
        "cta": "",
        "figure": ""
      },
      "boosters": {
        "title": "Open by batches",
        "body": "Open up to 50 available boosters in a single operation instead of 10. The stock and Anima you spend remain strictly identical.",
        "cta": "Open boosters",
        "figure": "10 → 50 boosters per batch"
      },
      "identity": {
        "title": "Supporter signature",
        "body": "Your name shows in gold with a crown. You also unlock the ANIDEX Keeper title, an orbital frame and avatar and banner effects.",
        "cta": "Style my profile",
        "figure": "Gold username, crown and orbital frame"
      },
      "images": {
        "title": "Personal images",
        "body": "Upload your avatar, banner and up to 20 portraits of cards you own. Only the image changes: rarity, value and stats stay unchanged.",
        "cta": "Choose my images",
        "figure": "Avatar, banner and 20 portraits"
      },
      "palette": {
        "title": "Personal colors",
        "body": "Choose the backgrounds, text, buttons and accents of the interface, separately for the Day and Night themes. Your palette stays visible to you only.",
        "cta": "Create my palette",
        "figure": "Private Day and Night palette"
      },
      "trades": {
        "title": "Wider trades",
        "body": "Offer up to 30 cards and 50,000 Anima per side of a trade. Each player's own limits still apply and fees stay the same.",
        "cta": "Open trades",
        "figure": "15 → 30 cards per side"
      },
      "done": {
        "title": "Nothing changes in the game",
        "body": "No extra Anima, boosters or rewards. Prices, odds and rewards stay identical for every player. Happy collecting.",
        "cta": "",
        "figure": "Same prices, same odds"
      }
    }
  },
  "tryout": {
    "eyebrow": "Demo",
    "title": "Try it without committing",
    "intro": "This preview is entirely local: nothing is saved or sent. Try the site colors, the appearance and your own images.",
    "username": "Collector",
    "paletteLabel": "Site colors",
    "paletteHint": "These colors only apply to this page while you browse. Nothing is saved.",
    "profileLabel": "Profile preview",
    "free": "Free",
    "premium": "Premium",
    "imagesLabel": "Your images (local)",
    "avatar": "Avatar",
    "banner": "Banner",
    "card": "Card portrait",
    "choose": "Choose an image",
    "change": "Change",
    "remove": "Remove",
    "cardTitle": "Custom card",
    "cardEmpty": "Choose a card image to preview it here.",
    "reset": "Clear all"
  }
}
